import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types';

class HeaderNavLink extends Component {
    render() {
        let isActive = this.context.router.route.location.pathname === this.props.to;
        let className = isActive ? "menu-item active" : "menu-item";

        return (
            <li className={className}>
                <NavLink {...this.props} className="menu-link">
                    <span className={"icon " + this.props.icon}></span>
                    <span className="title">{this.props.linkname}</span>
                    {this.props.count && this.props.count > 0 ? <span className="badge badge-pill badge-info">{this.props.count}</span> : null}
                    {this.props.beta ? <span className="badge badge-pill badge-success">beta</span> : null}
                </NavLink>
            </li>
        );
    }
}

HeaderNavLink.contextTypes = {
    router: PropTypes.object
};

export default HeaderNavLink;



// WEBPACK FOOTER //
// ./src/components/HeaderNavLink.js